import { TextStyle } from '@ticketmaster/global-design-system';
import { getEventDateRange, getEventStartLocalDateTime } from '../helpers/moment/moment.utils';
import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import { T } from '../helpers/i18n';
import { EventModel } from '../models/eventModel';
import styles from './dateAndLocation.module.scss';

type Props = {
  event: EventModel
} & T;

const DateAndLocation = ({ event, t }: Props) => {

  return (
    <>
      <div className={styles.dateLocation}>
        <TextStyle.Etna>
          {!!event.dateRange && getEventDateRange(event.dateRange)}
          {!event.dateRange && !!event.startLocalDate && getEventStartLocalDateTime(event.startLocalDate, event.startLocalTime)}
          {!event.dateRange && !event.startLocalDate && t('WALLET.INFO.TBA')}
        </TextStyle.Etna>
      </div>
      <div className={styles.dateLocation}>
        <TextStyle.Etna>
          {event.venue.title.replace(/\sat\s/, ' @ ')}&nbsp;-&nbsp;{event.venue.city}
        </TextStyle.Etna>
      </div>
    </>
)
  ;
};

export default withTranslation('translation')(memo(DateAndLocation));
